import PurchaseReturnForm from './purchase-return-form'
import GiftReturnsInstructions from './gift-returns-instructions'
import ReturnsLandingPage from './returns-landing-page'

export { PurchaseReturnForm, GiftReturnsInstructions, ReturnsLandingPage }
